import React from 'react';

const Tag = ({ children, className = '', style, ...props }) => (
  <span
    {...props}
    style={style}
    className={`inline-block px-2 py-1 rounded-lg text-sm bg-gray-100 text-gray-800 ${className}`}
  >
    {children}
  </span>
);

export default Tag;
